import { checkShowErrorInline, handleToastMutation } from '@/helpers';
import { apiCaller } from '@/redux/query';
import { handleToast } from '@/redux/slice/Toast/toast.slice';
import { Modal, TextField } from '@shopify/polaris';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

interface Props {
  isOpen: boolean;
  handleClose: () => void;
}

export const DiscountCodeModal = ({ ...props }: Props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('pricing');

  const [state, setState] = useState({
    discountCode: '',
    errorDiscount: '',
  });

  const [discountMutation, { isLoading }] = apiCaller.useApplyDiscountCodeMutation();

  const applyDiscountCode = () => {
    discountMutation(state.discountCode).then((res) => {
      const condition = checkShowErrorInline(res);
      if (condition.statusCode) {
        setState({ ...state, errorDiscount: t(condition.message) });
      } else {
        dispatch(handleToast(handleToastMutation(res, t)));
        setState({ errorDiscount: '', discountCode: '' });
        props.handleClose();
      }
    });
  };

  return (
    <Modal
      open={props.isOpen}
      onClose={props.handleClose}
      title={t('apply_discount_code')}
      primaryAction={{
        content: t('apply'),
        onAction: applyDiscountCode,
        disabled: state.discountCode === '',
        loading: isLoading,
      }}
    >
      <Modal.Section>
        <TextField
          autoComplete="off"
          label={t('discount_code')}
          value={state.discountCode}
          onChange={(value) => {
            setState({
              ...state,
              discountCode: value,
              errorDiscount: '',
            });
          }}
          onBlur={() => {
            setState({
              ...state,
              errorDiscount: state.discountCode === '' ? t('discount_code_missing') : '',
            });
          }}
          error={state.errorDiscount}
        />
      </Modal.Section>
    </Modal>
  );
};
